import {
  CLEAR_SUCCESSFUL_BOOKING_DATA,
  BOOKING_RESPONSE_RECEIVED,
  BOOKING_REQUEST_FAILED,
  BOOKING_REQUEST_SUBMITTED,
  BOOKING_REQUEST_NOT_SUBMITTED,
  BOOKING_CLEAR_ERRORS,
  BOOKING_INSURANCE_TYPE,
  PROFILE_FORM_SUBMITTED,
  BOOKING_REQUESTED_TIME_CHANGED,
  PROFILE_FORM_SUBMISSION,
  INSURANCE_FORM_SUBMITTED,
  INSURANCE_FORM_NOT_SUBMITTED,
  INSURANCE_CLEAR,
  INSURANCE_FORM_SUBMISSION,
  SYMPTOM_SELECTED,
  SYMPTOM_UPDATED,
  SET_ACTIVE_LOCATION,
  BOOKING_SET_LOCATION_ID,
  BOOKING_TIME_SELECTED,
  BOOKING_SET_IS_EXISTING_PATIENT,
  BOOKING_SET_HAS_BOOKED_HERE_BEFORE_WITH_SOLV,
  INSURANCE_OCR_DATA,
  PATIENT_TYPE_CHANGED,
  POSITION_SUCCESS,
  SYMPTOM_CLICKED,
  SYMPTOMS_SUBMIT,
  BOOKING_REASON_FOR_VISIT_CHANGED,
  BOOKING_RECEIVE_USER_PROFILE,
  BOOKING_ORIGIN_CHANGED,
  BOOKING_NOTES,
  BOOKING_APPOINTMENT_TYPE,
  LOCATION_SLOTS_RECEIVED,
  LOGIN_RESET_LOGIN_DATA,
} from '../constants';
import moment from 'moment-timezone';
import { getNearestSlotAvailable, getFirstAvailableAppointmentTime } from '../core/location/slots';
import { isEmptyObject } from '../core/util/object';

export const newBookingInitialState = {
  booking: {},
  insurance: {},
  profile: { isExistingPatient: false },
};

const createInitialState = () => newBookingInitialState;

export default function bookingReducer(state = createInitialState(), action) {
  switch (action.type) {
    case BOOKING_REASON_FOR_VISIT_CHANGED:
      return {
        ...state,
        booking: {
          ...state.booking,
          reasonForVisit: action.payload.value,
        },
      };
    case BOOKING_ORIGIN_CHANGED:
      return {
        ...state,
        booking: {
          ...state.booking,
          origin: action.payload.value,
        },
      };
    case BOOKING_RESPONSE_RECEIVED:
      return {
        ...state,
        lastCreatedBookingId: !isEmptyObject(action.payload.value)
          ? action.payload.value.booking_id
          : null,
        lastCreatedBookingPhone: state.profile.phone,
        error: null,
        submitting: false,
        submitSuccess: true,
        isSymptomClicked: false,
      };
    case CLEAR_SUCCESSFUL_BOOKING_DATA:
      return {
        ...state,
        ...createInitialState(),
      };
    case BOOKING_REQUEST_FAILED:
      return {
        ...state,
        error: action.payload.value,
        submitting: false,
      };
    case BOOKING_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    case INSURANCE_CLEAR:
      return {
        ...state,
        insurance: {},
        submitting: false,
      };
    case BOOKING_REQUEST_SUBMITTED:
    case PROFILE_FORM_SUBMITTED:
    case INSURANCE_FORM_SUBMITTED:
      return {
        ...state,
        submitting: true,
        submitSuccess: false,
      };
    case BOOKING_REQUEST_NOT_SUBMITTED:
    case INSURANCE_FORM_NOT_SUBMITTED:
      return {
        ...state,
        submitting: false,
      };
    case PROFILE_FORM_SUBMISSION:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload.value,
        },
        submitting: false,
      };
    case INSURANCE_FORM_SUBMISSION:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          ...action.payload.value,
        },
        submitting: false,
      };
    case SYMPTOM_SELECTED:
      return {
        ...state,
        booking: {
          ...state.booking,
          reasonForVisit: action.payload.value.symptoms,
          patientType: action.payload.value.patientType,
        },
      };
    case SYMPTOM_UPDATED:
      return {
        ...state,
        booking: {
          ...state.booking,
          reasonForVisit: action.payload.value,
        },
      };
    case SYMPTOM_CLICKED:
      return {
        ...state,
        isSymptomClicked: action.payload.value,
      };
    case PATIENT_TYPE_CHANGED:
      return {
        ...state,
        booking: {
          ...state.booking,
          patientType: action.payload.value,
        },
      };
    case BOOKING_SET_LOCATION_ID:
      return {
        ...state,
        booking: {
          ...state.booking,
          locationId: action.payload.value,
        },
      };
    case SET_ACTIVE_LOCATION:
    case LOCATION_SLOTS_RECEIVED: {
      let appointmentTime;

      if (isEmptyObject(state.booking)) {
        const location = action.payload.value;
        appointmentTime = getNearestSlotAvailable(location, moment().tz(location.timeZone));
      } else if (!isEmptyObject(state.booking) && state.booking.appointmentTime) {
        appointmentTime = state.booking.appointmentTime;
      } else {
        appointmentTime = state.booking.requestedAppointmentTime
          ? getNearestSlotAvailable(action.payload.value, state.booking.requestedAppointmentTime)
          : getFirstAvailableAppointmentTime(action.payload.value);
      }

      return {
        ...state,
        booking: {
          ...state.booking,
          locationId: action.payload.value.id || state.booking.locationId,
          appointmentTime,
        },
      };
    }

    case BOOKING_REQUESTED_TIME_CHANGED:
      return {
        ...state,
        booking: {
          ...state.booking,
          requestedAppointmentTime: action.payload.value,
          appointmentTime: null,
        },
      };
    case BOOKING_TIME_SELECTED:
      return {
        ...state,
        booking: {
          ...state.booking,
          appointmentTime: action.payload.appointmentTime,
        },
      };
    case BOOKING_SET_IS_EXISTING_PATIENT:
      return {
        ...state,
        profile: {
          ...state.profile,
          isExistingPatient: action.payload.value,
        },
      };
    case BOOKING_SET_HAS_BOOKED_HERE_BEFORE_WITH_SOLV:
      return {
        ...state,
        hasBookedHereBeforeWithSolv: action.payload.value,
      };
    case BOOKING_NOTES:
      return {
        ...state,
        booking: {
          ...state.booking,
          notes: action.payload.value,
        },
      };
    case BOOKING_APPOINTMENT_TYPE:
      return {
        ...state,
        booking: {
          ...state.booking,
          appointmentType: action.payload.value,
        },
      };
    case INSURANCE_OCR_DATA:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          ...action.payload.value,
        },
      };
    case BOOKING_INSURANCE_TYPE:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          insurerType: action.payload.value,
        },
      };
    case POSITION_SUCCESS:
      return {
        ...state,
        booking: {
          ...state.booking,
          latitude: action.payload.value.latitude,
          longitude: action.payload.value.longitude,
        },
      };
    case BOOKING_RECEIVE_USER_PROFILE:
      return {
        ...state,
        booking: {
          ...state.booking,
          userProfileId: action.payload.value.user_profile_id,
          userProfile: action.payload.value,
        },
      };

    case SYMPTOMS_SUBMIT: {
      const newState = {
        ...state,
        booking: {
          ...state.booking,
        },
      };

      if (action.payload.value.symptoms) {
        newState.booking.reasonForVisit = action.payload.value.symptoms;
      }

      if (action.payload.value.appointmentTime) {
        newState.booking.requestedAppointmentTime = action.payload.value.appointmentTime;
      }

      if (action.payload.value.patientType) {
        newState.booking.patientType = action.payload.value.patientType;
      }

      if (action.payload.value.requestedInsurance) {
        newState.booking.requestedInsurance = action.payload.value.requestedInsurance;
      }

      return newState;
    }

    case LOGIN_RESET_LOGIN_DATA:
      return {
        ...state,
        booking: {
          ...state.booking,
          userProfileId: null,
          userProfile: null,
        },
      };

    default:
      return state;
  }
}
